// extracted by mini-css-extract-plugin
module.exports = {"trigger":"_3Su4fr"};